/* eslint-disable @typescript-eslint/no-explicit-any */

import { FileDeleteOptions, ICreateFileOptions, IFileContent, IFileStatWithMetadata, IReadFileOptions, IWriteFileOptions } from './files';
import { Event } from '@malagu/core/lib/common/utils/event';

export { Event } from '@malagu/core/lib/common/utils/event';
export { Emitter } from '@malagu/core/lib/common/utils/emitter';
export { CancellationTokenSource } from '@malagu/core/lib/common/utils/cancellation';

export class ProxyIdentifier<T> {
    public readonly id: string;
    constructor(public readonly isMain: boolean, id: string | T) {
        // TODO this is nasty, rewrite this
        this.id = (id as any).toString();
    }
}

export function createProxyIdentifier<T>(identifier: string): ProxyIdentifier<T> {
    return new ProxyIdentifier(false, identifier);
}

export interface CommandService {
    executeCommand<T = any>(commandId: string, ...args: any[]): Promise<T | undefined>;
}

export interface FileService {

    readFile(resource: string, options?: IReadFileOptions): Promise<IFileContent>;

    writeFile(resource: string, content: string, options?: IWriteFileOptions): Promise<IFileStatWithMetadata>;

    createFile(resource: string, content?: string, options?: ICreateFileOptions): Promise<IFileStatWithMetadata>;

    createFolder(resource: string): Promise<IFileStatWithMetadata>;

    del(resource: string, options?: Partial<FileDeleteOptions>): Promise<void>;

    exists(resource: string): Promise<boolean>;

    copy(source: string, target: string, overwrite: boolean | undefined): Promise<IFileStatWithMetadata>;

}

export interface ActiveEditorChangeEvent {
    uri?: {
        path: string;
        scheme: string;
    };
    editorType?: string;
}

export const enum PersistentConnectionEventType {
    ConnectionLost,
    ReconnectionWait,
    ReconnectionRunning,
    ReconnectionPermanentFailure,
    ConnectionGain
}
export class ConnectionLostEvent {
    public readonly type = PersistentConnectionEventType.ConnectionLost;
    constructor(
        public readonly reconnectionToken: string,
        public readonly millisSinceLastIncomingData: number
    ) { }
}
export class ReconnectionWaitEvent {
    public readonly type = PersistentConnectionEventType.ReconnectionWait;
    constructor(
        public readonly reconnectionToken: string,
        public readonly millisSinceLastIncomingData: number,
        public readonly durationSeconds: number
    ) { }
}
export class ReconnectionRunningEvent {
    public readonly type = PersistentConnectionEventType.ReconnectionRunning;
    constructor(
        public readonly reconnectionToken: string,
        public readonly millisSinceLastIncomingData: number,
        public readonly attempt: number
    ) { }
}
export class ConnectionGainEvent {
    public readonly type = PersistentConnectionEventType.ConnectionGain;
    constructor(
        public readonly reconnectionToken: string,
        public readonly millisSinceLastIncomingData: number,
        public readonly attempt: number
    ) { }
}
export class ReconnectionPermanentFailureEvent {
    public readonly type = PersistentConnectionEventType.ReconnectionPermanentFailure;
    constructor(
        public readonly reconnectionToken: string,
        public readonly millisSinceLastIncomingData: number,
        public readonly attempt: number,
        public readonly handled: boolean
    ) { }
}
export type PersistentConnectionEvent = ConnectionGainEvent | ConnectionLostEvent | ReconnectionWaitEvent | ReconnectionRunningEvent | ReconnectionPermanentFailureEvent;

export interface Message {
    type: string;
    data?: any;
}

export interface EditorService {
    onDidActiveEditorChange: Event<ActiveEditorChangeEvent>;
    handleActiveEditorChange(event: ActiveEditorChangeEvent): void;
}

export interface RemoteAgentConnection {
    onDidStateChange: Event<PersistentConnectionEvent>;
    handleStateChange(event: PersistentConnectionEvent): void;
}

export interface NotifyService {
    onDidMessageReceive: Event<Message>;
    handleMessageReceive(message: Message): void;
}

export const RPC_CONTEXT = {
    CommandService: createProxyIdentifier<CommandService>('CommandService'),
    FileService: createProxyIdentifier<FileService>('FileService'),
    EditorService: createProxyIdentifier<EditorService>('EditorService'),
    RemoteAgentConnection: createProxyIdentifier<RemoteAgentConnection>('RemoteAgentConnection'),
    NotifyService: createProxyIdentifier<NotifyService>('NotifyService')
};
